
<div class="email-component">
  <form [formGroup]="formGroup">
    <mat-form-field>
      <mat-label>{{title}} @if (mandatory) {
        <span> *</span>
      }</mat-label>
      <input matInput [inputMask]="createEmailInputMask"
        placeholder="{{placeholder ? placeholder : 'Enter your email...'}}" type="text"
        [formControl]="formControl" [disableControl]="disabled">
        @for (errorKey of errorKeys(formControl); track errorKey) {
          <mat-error>
            @if (formControl.touched && formControl.hasError(errorKey)) {
              {{errorMessage(formControl, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </form>
  </div>
